import React from "react";
import PropTypes from "prop-types";
import ActivateAccountBadge from "../../../common/ActivateAccountBadge";
import "./AccountCTAActivateAccountBadge.scss";

const AccountCTAActivateAccountBadge = ({ hasActiveGlobalAccount }) => {
    // Only render the badge if the user has not activated their account
    if (!hasActiveGlobalAccount) {
        return (
            <div className="account-cta-activate-account-badge grid">
                <div className="col col--12">
                    <div className="account-cta-activate-account-badge__container">
                        <ActivateAccountBadge />
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

AccountCTAActivateAccountBadge.propTypes = {
    hasActiveGlobalAccount: PropTypes.bool.isRequired,
};

export default AccountCTAActivateAccountBadge;
